import { render } from "./ImportSetupStep.vue?vue&type=template&id=390f600e&scoped=true"
import script from "./ImportSetupStep.vue?vue&type=script&lang=js"
export * from "./ImportSetupStep.vue?vue&type=script&lang=js"

import "./ImportSetupStep.vue?vue&type=style&index=0&id=390f600e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390f600e"]])

export default __exports__